module.exports = __webpack_public_path__ + "static/media/cart.ed1ff413.jpg";